import { render, staticRenderFns } from "./ChemUCI1LDFS4IL2.vue?vue&type=template&id=ec016c4e&scoped=true&"
import script from "./ChemUCI1LDFS4IL2.vue?vue&type=script&lang=js&"
export * from "./ChemUCI1LDFS4IL2.vue?vue&type=script&lang=js&"
import style0 from "./ChemUCI1LDFS4IL2.vue?vue&type=style&index=0&id=ec016c4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec016c4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VForm,VSelect})
